import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import App from './App'
import registerServiceWorker from './registerServiceWorker'
ReactDOM.render(<App />, document.getElementById('root'))
registerServiceWorker()

// function visibilityHandler() {
//   var hash = '#bg'
//   if (document.hidden && !window.location.hash) {
//     window.history.replaceState(null, null, window.location + hash)
//   } else if (!document.hidden && window.location.hash == hash) {
//     var l = '' + window.location
//     window.history.replaceState(null, null, l.substr(0, l.length - hash.length))
//   }
// }
// document.addEventListener('visibilitychange', visibilityHandler, false)
// visibilityHandler()

// var eventHandler = function(event) {
//   // Only run for iOS full screen apps
//   if (event.target.id === 'my-button-google') {
//     // Only run if link is an anchor and points to the current page

//     // Open link in same tab
//     event.preventDefault()
//     window.location = event.target.href
//   }
// }
// window.addEventListener('click', eventHandler, false)



// WEBPACK FOOTER //
// ./src/index.js